import { Reducer } from "redux";

import { SaveNotesResponse } from "../models/Api/Notes";
import { SaveNotesDispatchTypes } from "../models/DispatchTypes/Notes";
import { SaveAdminNotesActionDispatchTypes } from "../constants/Notes";

export const initialState: SaveNotesResponse = {
  loading: false,
  response: {
    templateVersionId: -1,
    noteTemplateId: -1,
    version: -1,
    templateJson: "",
    approvalStatusId: -1,
    approvalStatusName: "",
    templateCategoryId: -1,
    templateCategoryName: "",
    templateName: "",
    dateCreated: "",
    userCreated: "",
    showInHpPortal:false,
  },
};

const SaveNotesReducer: Reducer<SaveNotesResponse, SaveNotesDispatchTypes> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case SaveAdminNotesActionDispatchTypes.SAVE_NOTES_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case SaveAdminNotesActionDispatchTypes.SAVE_NOTES_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case SaveAdminNotesActionDispatchTypes.SAVE_NOTES_ERROR: {
      return {
        ...state,
        error: action.error,
        response: initialState.response,
        loading: false,
      };
    }
    case SaveAdminNotesActionDispatchTypes.SAVE_NOTES_RESET: {
      return initialState;
    }
  }
  return state;
};

export default SaveNotesReducer;
